'use client';

import useSWR from 'swr';
import { categoryBudgetApi } from '@/lib/api';
import type { CategoryRule } from '@/types';
import { TRANSACTION_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

/**
 * The user's merchant rules — all of them (`categoryRef` undefined), one category's
 * (`categoryRef` string), or disabled (`null`).
 */
export function useCategoryRules(categoryRef?: string | null) {
  const authedFetch = useAuthedFetcher();

  return useSWR<CategoryRule[]>(
    categoryRef === null ? null : ['category-rules', categoryRef ?? 'all'],
    () => authedFetch((token) => categoryBudgetApi.getRules(token, categoryRef ?? undefined)),
    TRANSACTION_SWR_OPTIONS,
  );
}
